import script from "./NewTopic.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewTopic.vue?vue&type=script&lang=ts&setup=true"

import "./NewTopic.vue?vue&type=style&index=0&id=76d1e5ac&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d1e5ac"]])

export default __exports__